/**
 * Chrome-less loading splash. Used by `<RequireAuth>` while the Medplum
 * SDK is resolving initial auth on the first paint, and as the Suspense
 * fallback for the unauthenticated route tree. Replaces the previous
 * "App returns null" first-paint state so users get visual feedback.
 *
 * Critically: this component renders no nav, no sidebar, no profile
 * chip, no logout — nothing that could leak the authenticated UI shape
 * to an anonymous viewport.
 *
 * @agentic connections
 */

import { Box, Center, MantineProvider } from "@mantine/core";
import { Logo } from "@benchmark/ui/components/atomic";
import gradientBackdropStyles from "@/styles/ConnectionsGradientBackdrop.module.css";

/** Centered logo on the brand backdrop. @agentic connections */
export const BootSplash = () => (
  <MantineProvider forceColorScheme="light">
    <Box
      className={gradientBackdropStyles.gradientBackdrop}
      style={{ minHeight: "100vh", width: "100vw" }}
    >
      <Center h="100vh">
        <Logo size={300} variant="extended" color="light" />
      </Center>
    </Box>
  </MantineProvider>
);
